import { render } from "./Got.vue?vue&type=template&id=07ca9d8b"
import script from "./Got.vue?vue&type=script&lang=js"
export * from "./Got.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__